// Status eines Dienstleisters (Handoff Dienstleister §6) – Priorität von oben nach unten.

import { deDatum } from '../immobilien/objektDetail';

export type DlStatus = 'inaktiv' | 'nachweis_abgelaufen' | 'rechnung_offen' | 'nachweis_laeuft_ab' | 'vertrag_endet' | 'aktiv';

export interface StatusEingabe {
  aktiv: boolean;
  nachweisAbgelaufen: boolean;
  offenBetrag: number;
  nachweisLaeuftAb: boolean;
  /** nächstes Vertragsende innerhalb der Vorwarnzeit */
  vertragEndet: string | null;
}

export function dlStatus(e: StatusEingabe): DlStatus {
  if (!e.aktiv) return 'inaktiv';
  if (e.nachweisAbgelaufen) return 'nachweis_abgelaufen';
  if (e.offenBetrag > 0.005) return 'rechnung_offen';
  if (e.nachweisLaeuftAb) return 'nachweis_laeuft_ab';
  if (e.vertragEndet) return 'vertrag_endet';
  return 'aktiv';
}

export const DL_STATUS: Record<DlStatus, { label: string; ton: 'neutral' | 'info' | 'warn' | 'bad' | 'ok' }> = {
  inaktiv: { label: 'Inaktiv', ton: 'neutral' },
  nachweis_abgelaufen: { label: 'Nachweis abgelaufen', ton: 'bad' },
  rechnung_offen: { label: 'Rechnung offen', ton: 'warn' },
  nachweis_laeuft_ab: { label: 'Nachweis läuft ab', ton: 'warn' },
  vertrag_endet: { label: 'Vertrag endet', ton: 'info' },
  aktiv: { label: 'Aktiv', ton: 'ok' },
};

export function statusText(s: DlStatus, vertragEndet: string | null): string {
  return s === 'vertrag_endet' && vertragEndet ? `Vertrag endet ${deDatum(vertragEndet)}` : DL_STATUS[s].label;
}
